<div class="header row">
  <button class="btn-close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
